import { render, staticRenderFns } from "./DescriptionListCard.vue?vue&type=template&id=418cfe38&"
import script from "./DescriptionListCard.vue?vue&type=script&lang=ts&"
export * from "./DescriptionListCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports